import React from 'react';
export default function QueryPreview({ value, onChange, placeholder = 'Paste or type your query here...' }) {
  const isEditable = typeof onChange === 'function';
  return (
    <div className='preview-box gb-box'>
      <div className='preview-top'>
        <strong>Query</strong>
        {isEditable && (
          <span style={{ fontSize: 12, color: 'inherit', opacity: 0.8, marginLeft: 8, fontWeight: 400 }}>
            (editable — paste or type)
          </span>
        )}
      </div>
      <div className='preview-body'>
        <textarea
          className='preview-area'
          value={value || ''}
          onChange={isEditable ? (e) => onChange(e.target.value) : undefined}
          readOnly={!isEditable}
          placeholder={isEditable ? placeholder : undefined}
          style={{ minHeight: 80 }}
        />
        <button className='btn primary' onClick={() => navigator.clipboard.writeText(value || '')}>Copy</button>
      </div>
    </div>
  );
}
